import { IDropdownOption } from "@fluentui/react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useTheme } from "react-jss";
import { ContentType } from "../../../../../common/enum/files/ContentType";
import { FileSize } from "../../../../../common/enum/files/FileSize";
import { useAppDispatch, useAppSelector } from "../../../../../redux/hooks";
import { IAssignmentQueueImportForm, updateFormProperty } from "../../../../../redux/reducers/request/assignmentQueue/form";
import { compileNameOfProperty, getGenericPayloadFromEvent } from "../../../../../utils";
import { Selector } from "../../../../common/selectors/selector";
import { Textarea } from "../../../../common/textarea/textarea";
import { UploadFileDropzone } from "../../../../common/uploadFileDropzone/uploadFileDropzone";
import { ImportRequest } from "../../container";
import { QueuAssignmentImportFormStyle } from "./formStyle.jss";

interface IVlcPortImportRequestFormProps {
    setDocument: (value: any) => any;
    codeComponent: string;
}

export enum ImportTypeCodeQueuAssignment {
    ANIMALORDER = "AnimalOrder",
    VEGETALORDER = "VegetalOrder",
}
export enum ImportTypeCodeQueuAssignmentDescription {
    ANIMALORDER = "ORDEN_ANIMAL",
    VEGETALORDER = "ORDEN_VEGETAL",
}

export const QueuAssignmentImportForm: React.FC<IVlcPortImportRequestFormProps> = ({ setDocument, codeComponent }) => {
    const theme = useTheme();
    const style = QueuAssignmentImportFormStyle({ theme });
    const dispatch = useAppDispatch();
    const [selectedKey, setSelectedKey] = useState<ImportTypeCodeQueuAssignment>(ImportTypeCodeQueuAssignment.ANIMALORDER);
    const onInputChange = (event: any) => {
        const payload = getGenericPayloadFromEvent(event);
        dispatch(updateFormProperty(payload));
    };
    const { t } = useTranslation("common", { keyPrefix: "APPOINTMENT.IMPORT" });

    const options: IDropdownOption<any>[] = [
        { key: ImportTypeCodeQueuAssignment.ANIMALORDER, text: ImportTypeCodeQueuAssignmentDescription.ANIMALORDER },
        { key: ImportTypeCodeQueuAssignment.VEGETALORDER, text: ImportTypeCodeQueuAssignmentDescription.VEGETALORDER },
    ];

    const onChange = (_event: React.FormEvent<HTMLDivElement>, option: any, name: string) => {
        setSelectedKey(option.key);
        dispatch(updateFormProperty({ name, value: option.key }));
    };

    const { form } = useAppSelector((state) => state.assignmentQueueImportForm);

    return (
        <div className={style.container}>
            <div>
                <Selector
                    title={t("DOCUMENT_TYPE")}
                    options={options}
                    onChange={onChange}
                    selectedKey={selectedKey}
                    name={compileNameOfProperty<IAssignmentQueueImportForm>("typeCode")}
                />
            </div>
            {codeComponent === ImportRequest.DOCUMENT && (
                <div className={style.file}>
                    <UploadFileDropzone
                        allowedExtensions={[ContentType.TXT]}
                        onFilesChange={setDocument}
                        disabled={false}
                        maxSize={FileSize._5MB}
                    />
                </div>
            )}

            {codeComponent === ImportRequest.CODE && (
                <div className={style.code}>
                    <Textarea
                        name={compileNameOfProperty<IAssignmentQueueImportForm>("document")}
                        onChange={onInputChange}
                        value={form.document}
                        label={t("CODE_TXT")}
                    />
                </div>
            )}
        </div>
    );
};
